import request from '@/utils/request'

/**
 * 运行统计
 * @param pv
 */
export function runEventCount(pv) {
	return request({
		url: `/robotRunning/runEventCount/${pv}`,
		method: 'get'
	})
}
// ---m3u8----- 
export function getM3u8Video(data) {
	return request({
		url: '/robotVideoStream/start',
		method: 'post',
		data
	})
}
export function getWebrtcPlay(data) {
	return request({
		url: '/robotVideoStream/webrtcPlay',
		method: 'post',
		data
	})
}
// -香港非私有化--m3u8----- 
export function getXM3u8Video(data) { 
    return request({
        baseURL: config.hkM3u8Url,
        url: '/robotVideoStream/start',
        method: 'post',
        data
    })
}
/**
 * 事件统计与实时事件列表
 * @param pv
 */
export function currentCount(pv) {
	return request({
		url: `/event/currentCount/${pv}`,
		method: 'get'
	})
}

/**
 * 环境信息机器人下拉选
 * @param pv
 */
export function robotSelect(pv) {
	return request({
		url: `/robot/robotSelect/${pv}`,
		method: 'get'
	})
}

/**
 * 环境信息
 * @param pv
 */
export function environmentRobotNum(pv, type) {
	return request({
		url: `/environment/robotNum/${pv}/${type}`,
		method: 'get'
	})
}

/**
 * 员工评分效率
 * @param pv
 */
export function scoreList(pv, type) {
	return request({
		url: `/staff/scoreList/${pv}/type/${type}`,
		method: 'get'
	})
}

/**
 * 事件类型饼状图
 * @param pv
 */
export function mapEventType(pv) {
	return request({
		url: `/event/mapEventType/${pv}/1`,
		method: 'get'
	})
}

/**
 * 获取事件图片与巡检打卡图片轮播
 * @param pv
 */
export function getEventImgListByType(pv) {
	return request({
		url: `/event/getEventImgListByType`,
		method: 'post',
		data: {
			...pv
		}
	})
}

/**
 * 租户事件类型下拉
 * @param pv
 */
export function excludeCheckPatrolEventTypeList(tenantInfoId) {
	return request({
		url: `/event/excludeCheckPatrolEventTypeList/${tenantInfoId}`,
		method: 'get'
	})
}

/**
 * 事件热力图
 * @param pv
 */
export function eventThermogram(pv) {
	return request({
		url: `/event/eventThermogram`,
		method: 'post',
		data: {
			...pv
		}
	})
}
/**
 * 地图
 * @param pv
 */
export function mapList(tenantInfoId) {
	return request({
		url: `/robot/mapList?tenantInfoId=${tenantInfoId}`,
		method: 'get'
	})
}

/**
 * 地图下机器人
 * @param pv
 */
export function positonList(pv) {
	return request({
		url: `/robot/positonList`,
		method: 'post',
		data: {
			...pv
		}
	})
}

/**
 * 机器详情信息
 * @param pv
 */
export function robotDetail(robotId) {
	return request({
		url: `/robot/detail/${robotId}`,
		method: 'get'
	})
}

/**
 * 获取机器地图与路线信息
 * @param pv
 */
export function mapRoute(robotId) {
	return request({
		url: `/robot/mapRoute/${robotId}`,
		method: 'get'
	})
}

/**
 * 获取机器地图与路线信息
 * @param pv
 */
export function currentDuty(robotId) {
	return request({
		url: `/robot/currentDuty/${robotId}`,
		method: 'get'
	})
}

/**
 * 获取获取租户最新的天气信息
 * @param pv
 */
export function environmentGetInfo(tenantInfoId) {
	return request({
		url: `/environment/getInfo/${tenantInfoId}`,
		method: 'get'
	})
}

/**
 * 获取所有事件列表
 * @param pv
 */
export function eventTypeByTenantInfoId(tenantInfoId) {
	return request({
		url: `/event/eventTypeByTenantInfoId?tenantInfoId=${tenantInfoId}`,
		method: 'get'
	})
}

/**
 * 获取租户启用状态的地图列表
 * @param pv
 */
export function tenantInfoMapRoute(tenantInfoId) {
	return request({
		url: `/robot/tenantInfoMapRoute/${tenantInfoId}`,
		method: 'get'
	})
}

/**
 * 获取视频列表
 * @param param
 */
export function getVideoList(param) {
	return request({
		url: `/robot/getVideoPlaybackStreamList`,
		method: 'post',
		data: param
	})
}

/**
 * 获取视频列表
 * @param param
 */
export function queryRobotReplayVideoList(param) {
	return request({
		url: `/robot/queryRobotReplayVideoList`,
		method: 'post',
		data: param
	})
}

export function getVideoRobotList(tenantInfoId) {
	return request({
        url: `/robot/openVideoPlaybackRobotList/`+tenantInfoId,
		method: 'get',
	})
}

// 台账功能
/**
 * 获取机器人台账状态
 * @param pv
 */
export function getLedgerStatus(robotNumber) {
	return request({
		url: `/ledger/getLedgerStatus?robotNumber=${robotNumber}`,
		method: 'get'
	})
}
/**
 * 开始/结束采集台账
 * @param param
 */
export function switchLedger(param) {
	return request({
		url: `/ledger/startLedger`,
		method: 'post',
		data: param
	})
}
/**
 * 发送指示灯指令
 * @param param
 */
export function sendIndicatorLight(param) {
	return request({
		url: `/robot/sendIndicatorLight`,
		method: 'post',
		data: param
	})
}


// WEBPACK FOOTER //
// ./src/api/indexV2.js